module.exports = __webpack_public_path__ + "static/media/miasano-hero-small.13bed19b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/miasano-hero-small.jpg
// module id = 582
// module chunks = 0